<template>
    <div>
        <top-header/>
        <div class="container-fluid text-left text-md-center mt-4" style="margin-bottom: 8rem;">
            <div v-if="history && history.length > 0">
                <h1 class="mt-1 mb-2 text-info">Tests History</h1>
                <hr/>
                <v-client-table :data="history" :columns="columns" :options="options">
                    <div slot="date" slot-scope="props">
                        <div>{{ props.row.date | moment('dddd, MMMM Do YYYY') }}</div>
                        <div class="text-muted">{{ props.row.date | moment('HH:mm:ss') }}</div>
                    </div>

                    <div slot="controls" slot-scope="props">
                        <router-link class="btn btn-outline-secondary" data-cy="viewReportButton"
                                     :to="{ name: 'ResultsScreen', params: { testId: props.row.testId }}">
                            <i class="fas fa-table"/> View Report
                        </router-link>
                    </div>
                </v-client-table>
            </div>
            <div v-else class="mt-4">
                <i class="fas fa-history fa-3x text-muted"></i>
                <h4 class="mt-3 text-dark text-uppercase">
                    No Tests Yet!
                </h4>
                <p>
                    Tests History uses browser's <a href="https://en.wikipedia.org/wiki/Web_storage#Local_and_session_storage" target="_blank">local storage <i class="fas fa-external-link-alt"></i></a> which will persist between browser restarts.
                    However, please keep in mind that if you switch your browser, computer/device or clear the browser's local storage then the history will not be here.
                </p>
                <router-link to="/" class="btn btn-outline-primary mt-2">
                    Get Started <i class="fas fa-arrow-circle-right"></i>
                </router-link>
            </div>
        </div>

        <bottom-footer/>
    </div>
</template>

<script>
    import TopHeader from "../TopHeader";
    import BottomFooter from "../decorators/BottomFooter";
    import FiltersService from "../../services/FiltersService";

    export default {
        name: "TestsHistory",
        components: {BottomFooter, TopHeader},
        data() {
            return {
                columns: ['date', 'testType', 'testPattern', 'controls'],
                options: {
                    filterable: false,
                    pagination: {dropdown: false},
                    perPage: 40,
                    perPageValues: [],
                    headings: {
                        date: 'Date Performed',
                        testId: 'Test Id',
                        testType: 'Test Type',
                        testPattern: 'Test Pattern',
                        controls: 'View Report',
                    },
                    sortable: ['sortOrder', 'filterName', 'rating', 'baseline'],
                    sortIcon: {base: 'fa', up: 'fa-sort-up', down: 'fa-sort-down', is: 'fa-sort'},
                    columnsDisplay: {
                        "testType": "not_mobile",
                        "testPattern": "not_mobile",
                    },
                },
                history: null,
            };
        },
        mounted() {
            let historyTmp = FiltersService.getHistory();
            if (historyTmp){
                historyTmp = historyTmp.sort((a, b) => this.$moment(b.date) - this.$moment(a.date) );
            }
            this.history = historyTmp;
        },
    }
</script>

<style scoped>

</style>
